import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class AssessmentTaskNotificationReplayService {
    private readonly sameRouteClicks = new Subject<number>();

    readonly clicks = this.sameRouteClicks.asObservable();

    request(taskId: number): void {
        this.sameRouteClicks.next(taskId);
    }
}
